<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import videoComponent from "./production/video-component-output-tab.vue";
import floppyDisk from "../../../../static/assets/images/floppy-disk.svg";
export default {
  name: "OutputsTab",
  components: { videoComponent },
  data() {
    return {
      floppyDisk,
      shortDescriptionLimitCount: 500,
      longDescriptionLimitCount: 500,
    };
  },
  computed: {
    ...mapGetters({
      currentActivity: "warmups/currentActivity",
      currentVideos: "warmups/currentVideos",
    }),

    warmup_chapterisation_short_description: {
      set(value) {
        this.$store.commit("warmups/setActivityField", {
          fieldName: "warmup_chapterisation_short_description",
          value,
        });
      },
      get() {
        if (this.currentActivity) {
          return this.currentActivity.warmup_chapterisation_short_description;
        }
        return "";
      },
    },
    warmup_chapterisation_long_description: {
      set(value) {
        this.$store.commit("warmups/setActivityField", {
          fieldName: "warmup_chapterisation_long_description",
          value,
        });
      },
      get() {
        if (this.currentActivity) {
          return this.currentActivity.warmup_chapterisation_long_description;
        }
        return "";
      },
    },
  },

  methods: {
    updateActivity() {
      this.$store.commit("commons/setPreloader", true);
      this.$store
        .dispatch("warmups/updateActivity", this.$route.params.id)
        .then((res) => {
          this.$store
            .dispatch("warmups/updateVideo", this.$route.params.id)
            .then((res) => {
              this.$store.commit(`commons/setSavingForm`, "Saved");
              this.$store.commit(`warmups/setTabStatus`, false);
              this.$store.commit("commons/setPreloader", false);
            });
        });
    },
    makeToast(variant = null, title, message) {
      this.$bvToast.toast(message, {
        title: `${title || "default"}`,
        variant: variant,
        solid: true,
      });
    },
  },
  async mounted() {
    if (this.currentActivity.id)
      this.$store.dispatch(`warmups/getCurrentVideos`, this.currentActivity.id);
  },
};
</script>

<template>
  <div class="px-5 py-5">
    <video-component
      v-for="(video, index) of currentVideos"
      :key="index"
      :index="index"
      :video="video"
    >
    </video-component>
    <button class="floating-btn btn no-outline" @click="updateActivity()">
      <span class="d-flex justify-content-center align-items-center">
        <img :src="floppyDisk" />
      </span>
    </button>
  </div>
</template>